import { Injectable } from '@angular/core';
import { addMinutes, differenceInMinutes, format, parse, subDays } from 'date-fns';
import { es } from 'date-fns/locale';

@Injectable()
export class DateHelper {
    constructor() { }

    obtenerFechaHoy(formato: string, fecha: Date){
        const fechaFormateada = format(fecha, formato, { locale: es });
        return fechaFormateada;
    }
    
    sumarMinutos(horaActual : any, minutosASumar: number) {
        const horaSumada = addMinutes(horaActual, minutosASumar);
        return format(horaSumada, 'HH:mm:ss');
      }

    sumarMinutosAFecha(fecha : any, minutosASumar: number) {
        const horaSumada = addMinutes(fecha, minutosASumar);
        return horaSumada;
      }

    sumarDias(fechaActual:any, cantidadDias:number){
        const fechaSumada = new Date(fechaActual);
        fechaSumada.setDate(fechaSumada.getDate() + cantidadDias);
        return fechaSumada;
    }

    diferenciaMinutos(hora1: any, hora2: any) {
        const diferencia = differenceInMinutes(hora2, hora1);
        return diferencia;
      }

      restarDias(fecha: any, dias: number): Date {
        const fechaHace7Dias = subDays(fecha, dias);
        return fechaHace7Dias;
      }

      obtenerHoraMinutos(hora: string): string {
        const partes = hora.split(':');
        const horas = partes[0];
        const minutos = partes[1].substring(0, 2);
        const horaYMinutos = `${horas}:${minutos}`;
        return horaYMinutos;
      }

      obtenerHoraMinutosSegundos(fecha: Date): string {
        return format(fecha, 'HH:mm:ss');
      }

      obtenerNumeroDiaSemana(fechaActual: any): number {
        let numeroDia = fechaActual.getDay();
        
        // Ajustar el valor del domingo de 0 a 7
        if (numeroDia === 0) {
          numeroDia = 7;
        }
        
        return numeroDia;
      }


      obtenerFechaLocal(fecha: any){
        // Convierte la fecha y hora a un objeto Date
        const fechaHora = new Date(fecha);

        // Ajusta la fecha y hora a la zona horaria local del cliente
        const fechaHoraLocal = new Date(fechaHora.getTime() - fechaHora.getTimezoneOffset() * 60000);

        // // Formatea la fecha y hora local en el formato deseado
        // const fechaHoraFormateada = format(fechaHoraLocal, 'yyyy-MM-dd HH:mm:ss');

        return fechaHoraLocal; // Imprime la fecha y hora ajustada y formateada en la zona horaria local del cliente
      }

}
